export const ACCA_WIDGET = {
  pages: {
    bets: 0,
    betSlip: 1,
  },

  numOfPages: 2,
}